import { render, staticRenderFns } from "./MemberClubView.vue?vue&type=template&id=312b5550&scoped=true&"
import script from "./MemberClubView.vue?vue&type=script&lang=ts&"
export * from "./MemberClubView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312b5550",
  null
  
)

export default component.exports